export default __webpack_public_path__ + "static/media/PerryLogan-Thumbnail.d1d8af57.png";